import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const createAddonsReducer = ({}) => {
    const initialState = {
        isShown: false,
    }

    return handleActions({
        [ActionTypes.ADDONS_MENU_TOGGLE]: (state) => ({
            ...state,
            isShown: !state.isShown,
        }),
        [ActionTypes.ADDONS_MENU_CLOSE]: (state) => ({
            ...state,
            isShown: false,
        }),
    }, initialState)
}

export default createAddonsReducer



// WEBPACK FOOTER //
// ./web/actiplans/js/addons/reducer.js